import React from "react";
import {
  AboutClasses,
  HeroClasses,
  PricingClasses,
  SkillsClasses,
  TrialBar,
  TechRequiredClasses,
} from "../../components";
import { aboutgamedesign, coding, gamedesignhero } from "../../assets/images";
import { Helmet } from "react-helmet";

const GameDesignClass = () => {
  return (
    <div>
      <Helmet>
        <title>Game Design Classes: Personalized Tech Education from the Experts | Tech Tails</title>
        <meta
          name="description"
          content="Empower your child with the skills to create their own games! Tech Tails Game Design Classes offer a unique blend of creativity and technology, turning gamers into creators."
        />
        <meta
          property="og:title"
          content="Game Design Classes for Kids | TechTails"
        />
        <meta
          property="og:description"
          content="Dive into game development with Tech Tails! Learn storytelling, character creation, and coding in our interactive Game Design classes for kids. Start creating today!"
        />
      </Helmet>
      <HeroClasses
        title="Game Design"
        tagline="Create Your Own Games From Scratch"
        desc="Your child will learn the complete game development process—from designing characters and levels to coding gameplay mechanics. Using tools like Unity, Roblox Studio, and Scratch, they'll build games they can actually play and share."
        img={gamedesignhero}
      />
      <AboutClasses
        title="What They'll Learn"
        desc="Students learn level design, character creation, game mechanics, and coding for gameplay. They'll understand how to balance difficulty, create engaging experiences, and bring their creative ideas to life through professional game development tools and techniques."
        image={aboutgamedesign}
      />
      <SkillsClasses
        title="Level Up Your Child's Skills"
        desc="Boost your kid's skills in a fun and cool way with our game design class!"
      />
      <PricingClasses
        title="Private 1:1 Pricing"
        desc="Our pricing is discounted as we enter the early stages of welcoming new students."
      />
      <TechRequiredClasses />
    </div>
  );
};

export default GameDesignClass;
